export default {
  en: {
    roadmap: "Roadmap",
    drive_timlelogs: "Track driving times",
    drive_timelogs_description:
      "Track your driving times and recorded kilometers. This way, you always have an overview of your trips and can use the data for your billing.",
    improved_team_management: "Improved team management",
    improved_team_management_description:
      "The goal of the improved team management is to enable better collaboration among teams while ensuring the necessary data privacy. Additionally, an extended authorization concept will allow for more granular permission management between team leaders and employees.",
    legal_working_hour_tracking: "Legal working hour tracking",
    legal_working_hour_tracking_description:
      "With legal working hour tracking, you can record your employees' working hours in compliance with regulations. This way, you always have an overview and can use the data for your billing.",
    overtime_tracking: "Track overtime",
    overtime_tracking_description:
      "Allow your employees to work and track overtime. Keep an overview of the extra hours worked and use them for your billing.",
    google_login: "Google Login",
    google_login_description:
      "Sign up and log in with your Google account. This way, you can quickly and easily access your account without remembering additional passwords. Ideal for freelancers.",
    vacation_tracking: "Track vacation time",
    vacation_tracking_description:
      "Track your employees' vacation time and implement approval processes. Vacations should also be visible to team members so they know who is on leave and when.",
    sick_leave_tracking: "Track sick leave",
    sick_leave_tracking_description:
      "Record your employees' sick leave and keep track of the days taken.",
  },
  de: {
    roadmap: "Roadmap",
    drive_timlelogs: "Fahrtzeiten erfassen",
    drive_timelogs_description:
      "Erfasse deine Fahrtzeiten und die gefahrenen Kilometer. So hast du deine Fahrten immer im Blick und kannst sie für deine Abrechnung nutzen.",
    improved_team_management: "Verbessertes Teammanagement",
    improved_team_management_description:
      "Mit der verbesserten Teamverwaltung ist es das Ziel, dass Teams besser miteinander kollaborieren können, jedoch auch der entsprechend notwendige Datenschutz gewährleistet ist. Zusätzlich soll durch ein erweitertes Autorisierungskonzept eine granularere Rechtevergabe zwischen Teamleiter und Mitarbeitendem verbessert werden.",
    legal_working_hour_tracking:
      "Arbeitszeiterfassung nach gesetzlichen Vorgaben",
    legal_working_hour_tracking_description:
      "Mit der Arbeitszeiterfassung nach gesetzlichen Vorgaben kannst du die Arbeitszeiten deiner Mitarbeiter gesetzeskonform erfassen. So hast du die Arbeitszeiten immer im Blick und kannst sie für deine Abrechnung nutzen.",
    overtime_tracking: "Überstunden erfassen",
    overtime_tracking_description:
      "Erlaube es deinen Mitarbeitenden, Überstunden zu machen und zu erfassen. Behalte den Überblick über die geleisteten Überstunden und nutze sie für deine Abrechnung.",
    google_login: "Google Login",
    google_login_description:
      "Erledige die Registrierung und Anmeldung mit deinem Google Account. So kannst du dich schnell und einfach anmelden und musst dir keine weiteren Passwörter merken. Ideal für Freelancer.",
    vacation_tracking: "Urlaubszeiten erfassen",
    vacation_tracking_description:
      "Erfasse die Urlaubszeiten deiner Mitarbeitenden und nutze entsprechende Genehmigungsprozesse. Die Urlaube sollen auch den Teammitgliedern angezeigt werden, sodass diese wissen, wann wer im Urlaub ist.",
    sick_leave_tracking: "Krankheitszeiten erfassen",
    sick_leave_tracking_description:
      "Erfasse die Krankheitszeiten deiner Mitarbeiter und behalte den Überblick über die genommenen Krankheitstage.",
  },
};
